import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import api from '../services/api';
import { Mail, ArrowLeft, Loader2, Check } from 'lucide-react';
import { GlassButton } from '../components/ui/GlassButton';
import logoPro from '../logo_pro.png';

export const ForgotPassword: React.FC = () => {
    const [email, setEmail] = useState('');
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState('');
    const [sent, setSent] = useState(false);

    const handleSubmit = async (e: React.FormEvent) => {
        e.preventDefault();
        if (!email) { setError('Informe seu e-mail.'); return; }
        setLoading(true);
        setError('');
        try {
            await api.post('/auth/forgot-password', { email });
            setSent(true);
        } catch (err: any) {
            setError(err.response?.data?.error || 'N\u00e3o foi poss\u00edvel enviar o e-mail. Tente novamente.');
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="auth-page min-h-screen flex items-center justify-center p-4">
            <div className="auth-card w-full max-w-md bg-white/5 border border-white/10 rounded-[32px] p-10 backdrop-blur-xl relative overflow-hidden">
                <div className="absolute top-[-50%] left-[50%] -translate-x-1/2 w-80 h-80 bg-orange-500/10 rounded-full blur-[80px] pointer-events-none" />
                <div className="relative z-10">
                    <div className="text-center mb-10">
                        <img src={logoPro} alt="Hotlize" className="h-10 mx-auto mb-6" />
                        <h1 className="text-2xl font-bold text-white mb-2">Recuperar Senha</h1>
                        <p className="text-gray-400 text-sm">Informe seu e-mail para receber o link de redefini&ccedil;&atilde;o</p>
                    </div>

                    {sent ? (
                        <div className="text-center py-8">
                            <div className="w-16 h-16 rounded-full bg-green-500/10 border border-green-500/20 flex items-center justify-center mx-auto mb-4">
                                <Check size={32} className="text-green-500" />
                            </div>
                            <h2 className="text-lg font-bold text-white mb-2">E-mail Enviado</h2>
                            <p className="text-gray-400 text-sm mb-6">
                                Se o e-mail estiver cadastrado, voc&ecirc; receber&aacute; um link para redefinir sua senha.
                            </p>
                            <Link to="/login" className="text-orange-500 font-bold hover:text-orange-400 transition-colors text-sm">
                                <ArrowLeft size={14} className="inline mr-1" /> Voltar ao login
                            </Link>
                        </div>
                    ) : (
                        <>
                            {error && (
                                <div className="bg-red-500/10 border border-red-500/20 text-red-500 p-4 rounded-xl mb-6 text-sm text-center">
                                    {error}
                                </div>
                            )}
                            <form onSubmit={handleSubmit} className="space-y-6">
                                <div className="input-group-pro">
                                    <label>E-MAIL</label>
                                    <div className="input-wrapper">
                                        <Mail size={18} className="text-gray-500" />
                                        <input
                                            type="email"
                                            placeholder="seu@email.com"
                                            value={email}
                                            onChange={e => setEmail(e.target.value)}
                                            required
                                            autoFocus
                                        />
                                    </div>
                                </div>
                                <GlassButton type="submit" className="w-full h-14" loading={loading}>
                                    {loading ? <Loader2 className="animate-spin" /> : 'ENVIAR LINK'}
                                </GlassButton>
                            </form>
                            <div className="mt-8 text-center text-sm">
                                <Link to="/login" className="text-gray-500 hover:text-white transition-colors">
                                    <ArrowLeft size={14} className="inline mr-1" /> Voltar ao login
                                </Link>
                            </div>
                        </>
                    )}
                </div>
            </div>
        </div>
    );
};
